/**
 * Page /admin/annuaire — Annuaire des tiers PARTAGÉ (mig 213).
 *
 * L'annuaire unique de la commune, filtrable par casquette d'usage (fournisseur,
 * client, organisme, partenaire/éditeur, bénéficiaire, assurance/banque,
 * intervenant/expert). Un tiers peut porter plusieurs casquettes ; chaque brique
 * ne voit ensuite que les catégories qui la concernent (ex. le service technique
 * filtre les fournisseurs pour une demande de devis).
 *
 * L'IBAN n'est PAS géré ici (il reste dans la comptabilité, sensible).
 */
import { BookUser } from 'lucide-react';
import { AnnuairePanel } from '@/components/annuaire/AnnuairePanel';

export function AnnuaireTiersPage() {
  return (
    <div className="mx-auto max-w-5xl px-4 py-6">
      <header className="mb-6">
        <h1 className="flex items-center gap-2 text-2xl font-semibold text-ink">
          <BookUser className="h-6 w-6 text-tech-fg" />
          Annuaire des tiers
        </h1>
        <p className="mt-1 text-sm text-ink-muted">
          Tous les contacts de la commune au même endroit : fournisseurs, clients,
          organismes, partenaires… Un contact peut avoir plusieurs casquettes, et
          chaque brique filtre selon son besoin.
        </p>
      </header>
      <AnnuairePanel />
    </div>
  );
}
